(function () {
  'use strict';

  var cardSelector = [
    '.item-product',
    '.product-card',
    '.collection-card',
    '.category-card',
    '.category-card-new',
    '.product-item',
    '.lkz-product-card',
    '.lkz-search-card',
    '.lkz-na-card',
    '.bookshelf-card',
    '.ehad-card',
    '.pbs5-card',
    '.pbs5c-card',
    '.pbsx-card',
    '.best-seller-card',
    '.new-arrival-card',
    '.lukzer-category-card',
    '.lukzer-new-arrivals-dark-card',
    '.lukzer-story-preview__card',
    '.lukzer-story-card',
    '.premium-review-carousel__card',
    '.customer-review-card',
    '.reel-card',
    '.lkz-reels__card',
    '.lukzer-ugc-card',
    '.lukzer-blog-card',
    '.lukzer-blog-featured',
    '[data-product-card]'
  ].join(',');

  var hoverImageSelector = [
    '.product__thumbnail-second',
    '.product-card__image--secondary',
    '.card__image--secondary',
    '.secondary-image',
    '.lkz-product-card__image--secondary',
    '.lkz-search-card__image--secondary',
    '.lkz-na-card__image--secondary',
    '.bookshelf-card__image--secondary',
    '.ehad-card__image--hover',
    '.pbs5-card__image--secondary',
    '.pbs5c-card__image--secondary',
    '.pbsx-card__image--secondary',
    '.best-seller-card__image--secondary',
    '.lukzer-new-arrivals-dark-card__image--secondary',
    '[data-hover-image]'
  ].join(',');

  function imageSource(image) {
    return image.currentSrc ||
      image.getAttribute('src') ||
      image.dataset.src ||
      (image.dataset.srcset ? image.dataset.srcset.split(',')[0].trim().split(/\s+/)[0] : '');
  }

  function preloadHoverImage(image) {
    if (!image || image.dataset.lukzerHoverPreloaded === 'true') return;
    var source = imageSource(image);
    if (!source) return;

    image.dataset.lukzerHoverPreloaded = 'true';
    image.decoding = 'async';

    var preload = new Image();
    preload.decoding = 'async';
    preload.src = source;
  }

  function stabilizeCard(card) {
    if (!card || card.dataset.hoverInitialized === 'true') return;
    card.dataset.hoverInitialized = 'true';
    card.querySelectorAll(hoverImageSelector).forEach(preloadHoverImage);
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(cardSelector).forEach(stabilizeCard);
  }

  function start() {
    initialize(document);

    if (!('MutationObserver' in window)) return;
    var frame = 0;
    var observer = new MutationObserver(function (mutations) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) initialize(node);
          });
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
